import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { CreateEmailVerificationCodeBySignerTokenRequest } from "@maven-rest/docs/DocumentSign.dto";
import { DocumentSignerRest } from "@maven-rest/docs/DocumentSigner.rest";
import { CreateUserVerificationCodeResponse } from "@maven-rest/sso/UserVerificationCode.dto";

export function useEmailVerificationCodeBySignerTokenMutation(req: {
  onSuccess: (
    data: CreateUserVerificationCodeResponse,
    variables: CreateEmailVerificationCodeBySignerTokenRequest,
    context: unknown
  ) => void;
  onError: (
    error: RestError<CreateUserVerificationCodeResponse>,
    variables: CreateEmailVerificationCodeBySignerTokenRequest,
    context: unknown
  ) => void;
}) {
  return useBaseMutation<CreateUserVerificationCodeResponse, CreateEmailVerificationCodeBySignerTokenRequest>({
    mutationFn: async (request: CreateEmailVerificationCodeBySignerTokenRequest) => {
      return await DocumentSignerRest.requestEmailVerificationCodeBySignerToken(request);
    },
    onSuccess: req.onSuccess,
    onError: req.onError,
  });
}
